export const PUBLIC_MARKETING_HEADER_COPY_PT = {
  "product": "Produto",
  "solutions": "Soluções",
  "tools": "Ferramentas",
  "resources": "Recursos",
  "platformExports": "Exportações de plataforma",
  "metadataTools": "Ferramentas de metadados",
  "display": "Exibição",
  "displayPreferences": "Configurações de exibição",
  "zoom": "Zoom",
  "theme": "Tema",
  "switchTheme": "Mudar de tema",
  "studio": "Estúdio aberto",
  "menu": "Menu",
  "closeMenu": "Fechar menu",
  "navigation": "Menu principal",
  "navigationDescription": "Explore produtos, ferramentas, recursos e configurações de conta Stocktag.",
  "account": "Conta",
  "legal": "Jurídico",
  "social": "Perfis sociais",
  "about": "Sobre",
  "editorial": "Política editorial",
  "contact": "Contato",
  "privacy": "Aviso de privacidade",
  "terms": "Termos de serviço"
};

export const PUBLIC_MARKETING_FOOTER_COPY_PT = {
  "ctaEyebrow": "Comece seu próximo lote aqui",
  "ctaTitle": "Publique suas imagens com metadados prontos para o mercado.",
  "ctaBody": "Crie, revise e exporte tudo em um único espaço de trabalho.",
  "studio": "Abra Metadata Studio",
  "seePricing": "Ver preços",
  "product": "Produto",
  "tools": "Ferramentas",
  "resources": "Recursos",
  "account": "Conta",
  "company": "Empresa",
  "legal": "Jurídico",
  "footerNavigation": "Navegação no rodapé",
  "platformExports": "Exportações de plataforma",
  "metadataTools": "Ferramentas de metadados",
  "tagline": "Um fluxo de trabalho completo de metadados para criadores de conteúdo stock.",
  "about": "Sobre",
  "editorial": "Política editorial",
  "contact": "Contato",
  "privacy": "Aviso de privacidade",
  "terms": "Termos de serviço",
  "social": "Perfis sociais Stocktag"
};

export const PUBLIC_MARKETING_FOOTER_FLOW_PT = {
  "label": "Fluxo de trabalho de publicação",
  "input": "Imagens de origem",
  "studio": "Metadata Studio",
  "review": "Metadados revisados",
  "export": "Arquivos prontos para upload"
};

export const PUBLIC_HOME_UI_COPY_PT = {
  "productSceneAlt": "Stocktag Metadata Studio com configurações de geração, espaço de trabalho de upload e controles de revisão de metadados",
  "aiBridgeAlt": "Ilustração de cidade sustentável criada no AI Image Studio, pronta para download antes do upload para Metadata Studio",
  "heroInputLabel": "Arquivo de origem",
  "heroAnalyze": "Análise visual concluída",
  "heroTitleReady": "Título e palavras-chave prontos",
  "heroReadyFor": "Pronto para Adobe Stock",
  "heroFileName": "alpine-hiker.jpg",
  "heroSampleTitle": "Caminhante com vista para um lago alpino calmo ao nascer do sol",
  "heroKeywords": [
    "caminhante",
    "lago alpino",
    "nascer do sol"
  ],
  "platformEyebrow": "Pronto para o mercado",
  "workflowEyebrow": "Um fluxo de trabalho contínuo",
  "exportEyebrow": "Pronto antes do upload",
  "trialEyebrow": "Demonstração de convidado",
  "trialLimit": "Uma avaliação está disponível por site e endereço IP todos os dias. Continue com o arquivo selecionado em Metadata Studio.",
  "videoDuration": "1 minuto 31 segundos",
  "capabilityEyebrow": "Cada recurso",
  "toolsEyebrow": "Ferramentas para o trabalho",
  "exploreAllTools": "Explore todas as ferramentas Stocktag",
  "marketEyebrow": "Inteligência de mercado",
  "sampleSignal": "Sinal de amostra",
  "exploreMarket": "Explorar Market Intelligence",
  "modulesEyebrow": "Ferramentas de estúdio",
  "exportsEyebrow": "Arquivos prontos para o Marketplace",
  "generatorEyebrow": "Estúdio de imagem de IA",
  "openGenerator": "Abra o AI Image Studio",
  "generateStep": "Gerar",
  "tagStep": "Baixar",
  "exportStep": "Carregar",
  "outputsEyebrow": "Um exemplo real de saída",
  "copy": "Copiar",
  "copied": "Copiado",
  "previewOnly": "Esta é uma visualização selecionável. A exportação ocorre em Metadata Studio.",
  "whyEyebrow": "Para contribuidores de bancos de imagens",
  "compareEyebrow": "Comparação de fluxo de trabalho",
  "beforeAfterEyebrow": "Do trabalho manual a um fluxo de trabalho controlado",
  "trustEyebrow": "Controle antes da exportação",
  "testimonialsEyebrow": "Exemplos de uso",
  "pricingEyebrow": "Escolha o plano certo",
  "faqEyebrow": "Perguntas frequentes",
  "routesEyebrow": "Continue explorando",
  "finalEyebrow": "Experimente agora",
  "beforeLabel": "Antes de Stocktag",
  "afterLabel": "Com Metadata Studio",
  "stocktagLabel": "Stocktag",
  "genericLabel": "IA de uso geral",
  "selectedPlatform": "Plataforma selecionada",
  "formatPreview": "Pré-visualização do formato",
  "workflowImages": [
    "Importando arquivos para Metadata Studio",
    "Configurações de geração de metadados",
    "Revisão de metadados em lote",
    "Controles de exportação do Marketplace"
  ]
};

export const HOME_SKIP_TO_MAIN_LABEL_PT = "Pular para o conteúdo principal";

export const HOME_MAIN_CONTENT_LABEL_PT = "Conteúdo inicial";


export default PUBLIC_HOME_UI_COPY_PT;
